export class PayMethod {
    public type: string;
    public last4: string;
    public expm: string;
    public expy: string;
    get text() {
        return `${this.last4}, EXP ${this.expm}/${this.expy}`;
    }
}
